import React, { useState, useEffect, useRef } from "react";
import Page from '../Page.js';
import uiManager from '../../../config/ui.js';
import PAGES from '../../data/PagesConstants.js';
import PageContentWrapper from "../../components/PageContentWrapper";
import { getApi } from "../../api/endpoints";
import { useParams, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import DetailsComponent from "../../components/DetailsComponent";
import SetUserBranch from "../../components/SetUserBranch";
import Multiselect from "multiselect-react-dropdown";
import HeadUser from '../../models/HeadUser';
import AreaUserMappingListing from '../area_user_mapping/Listing'
import { updateQueryParams, selectQueryParams } from "../../ui/customerListingReducer.js";
import { useSelector, useDispatch } from "react-redux";

const MapUser = () => {
  const [fetchApi] = getApi('showUser');
  const [pincodesApi] = getApi('pincodes');
  const [userPincodeMapApi] = getApi('createUserPincodeMap')
  const params = useParams();
  let headUserObj = new HeadUser({});
  const [headUser, setHeadUser] = useState(headUserObj.toStateJson());
  const selectedQueryParams = useSelector(selectQueryParams);
  const [pincodes, setPincodes] = useState([]);
  const [usersTypes , setUsersTypes] = useState([]);
  const [userBranch, setUserBranch] = useState(null);
  const [toMapPincodes, setToMapPincodes] = useState([]);
  const pincodeTextRef = useRef();
  const [usersTypesApi] = getApi('usersTypes');
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    getRecord({ id: params.id });
    fetchUsersTypes();
  }, []);

  useEffect(() => {
    if(userBranch) {
      getPincodes({ filters: {branch_ids: [userBranch]}, fields: "options" });
    }
  }, [userBranch])

  const getRecord = async (params) => {
    try {
      let response = await fetchApi(params).unwrap();
      headUserObj.setApiData(response.data.user);
      setUserBranch(headUserObj.branch_id);
      setHeadUser(headUserObj.toStateJson());
    } catch (error) {
      toast.error(error?.data?.message || "Something went wrong while fetching user details.")
    }
  }

  const makeDisticntPincodeObj = (all_pincodes) => {
    let set = new Set()
    let distinct_pincodes = all_pincodes.filter(pincode_obj => {
      if(!set.has(pincode_obj.pincode)) {
        set.add(pincode_obj.pincode);
        return true;
      }
      return false;
    })
    return distinct_pincodes
  }

  const getPincodes = async (params) => {
    try {
      let response = await pincodesApi(params).unwrap();
      let distinct_pincodes = makeDisticntPincodeObj(response.data.pincodes);
      setPincodes(distinct_pincodes);
    } catch (error) {
      toast.error(error?.data?.message || "Something went wrong while fetching pincodes.")
    }
  }

  const handleCancelFunction = () => {
    navigate('/manage_users');
  }

  const handleSubmitFunction = async (e) => {
    try {
      if(pincodeTextRef.current.value != '') {
        let typedPincode = pincodeTextRef.current.value.replace(/\s/g, "").split(',');
        let response = await userPincodeMapApi({
          user_id: headUser.id,
          pincodes: JSON.stringify(typedPincode),
          area_user_mappings: {user_id: headUser.id, company_id: 2, is_valid: true}
        }).unwrap();
      } else {
        let response = await userPincodeMapApi({
          user_id: headUser.id,
          pincodes: JSON.stringify(toMapPincodes),
          area_user_mappings: {user_id: headUser.id, company_id: 2, is_valid: true}
        }).unwrap();
      }
      dispatch(updateQueryParams(selectedQueryParams));
    } catch (error) {
      toast.error(error.data.message || "Something went wrong while mapping user.")
    }
  }

  const addPincode = (selectedList, selectedItem) => {
    setToMapPincodes((prevState)=>{
      return [...prevState, selectedItem.pincode];
    })
  }

  const removePincode = (selectedList ,removedItem) => {
    setToMapPincodes((prevState)=>{
      return prevState.filter((item)=> item = removedItem.pincod);
    })
  }

  const fetchUsersTypes = async () => {
    try {
      const response = await usersTypesApi({ filters: { mappable_users_types: true }}).unwrap();
      setUsersTypes(response.data.users_types.map(users_type => users_type.id));
    } catch (error) {
      toast.error(error.message || "Something went wrong while mapping user.")
    }
  }

  function intersection (a, b) {
    const setA = new Set(a);
    return b.filter(value => setA.has(value));
  }

  return <Page
    uiPage={uiManager.getUiPage(PAGES.MapHeadUserPage.name)}
    breadcrumbs={[{ label: "Home", url: '/dashboard' }, { label: "Head Users", url: '/manage_users' }, { label: "Map Head User" }]}
    className={'map-head-user-page'}
  >
    <PageContentWrapper contentHeading={"Map Head User"}>
      <DetailsComponent data={headUser} />
      <hr />
      <div className="m-2 mb-3">
        { intersection(headUser?.users_types?.map(users_type => users_type.id), usersTypes).length == 0 ? <></> :
        <>
          {
            headUser.branch_id ?
              <>
                <p style={{paddingLeft: "15px" }} className="h5 mt-5">
                  User <span className="text-success">{headUser.name}</span> is working in a circle <span className="text-success">{headUser.branch_id}-{headUser.branch_name}</span>.
                </p>
                <div className='container'>
                  <div className='row p-3'>
                    <div className='col'>
                      <label>Select pincodes to map</label>
                      <Multiselect
                        options={pincodes}
                        onSelect={addPincode}
                        onRemove={removePincode}
                        displayValue="pincode"
                        showArrow={true}
                        customArrow={true}
                        avoidHighlightFirstOption={true}
                      />
                    </div>
                    <div className="col text-center h5">OR</div>
                    <div className='col'>
                      <label htmlFor="pincodes_text">Type Comma Separated Pincodes</label>
                      <textarea ref={pincodeTextRef} className="form-control" id="pincodes_text" name="pincodes_text"></textarea>
                    </div>
                  </div>
                </div>

                <div className='mb-4 col-md-12'>
                  <button type="button" style={{ float: 'inline-start', width: '110px' }} className="btn btn-voltup-theme" onClick={handleCancelFunction}>
                    Back
                    </button>
                  <button type="button" style={{ float: 'inline-end', width: '110px' }} className="btn btn-voltup-theme ms-3" onClick={handleSubmitFunction}>
                    Submit
                  </button>
                </div>
              </>
            : <div className="m-2"><SetUserBranch/></div>
          }
        </>}
      </div>
      <div className="row mt-3"></div>
      <hr className="mt-5" />
      <div className="mt-5">
        <AreaUserMappingListing />
      </div>
    </PageContentWrapper>
  </Page>
}

export default MapUser;
